import { render, staticRenderFns } from "./InternetPushAnimationTile.vue?vue&type=template&id=38756fae&scoped=true&"
import script from "./InternetPushAnimationTile.vue?vue&type=script&lang=js&"
export * from "./InternetPushAnimationTile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38756fae",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/0/37614586/myshop/myshop/myshop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('38756fae')) {
      api.createRecord('38756fae', component.options)
    } else {
      api.reload('38756fae', component.options)
    }
    module.hot.accept("./InternetPushAnimationTile.vue?vue&type=template&id=38756fae&scoped=true&", function () {
      api.rerender('38756fae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/WEB-INF/views/orange/broadband/internet/showcase/components/InternetPushAnimationTile.vue"
export default component.exports